import { render, staticRenderFns } from "./ServersEdit.vue?vue&type=template&id=67daa0bd&scoped=true&"
import script from "./ServersEdit.vue?vue&type=script&lang=js&"
export * from "./ServersEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServersEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ServersEdit.vue?vue&type=style&index=1&id=67daa0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67daa0bd",
  null
  
)

component.options.__file = "ServersEdit.vue"
export default component.exports